import { defineMessages } from "react-intl";
import { ConditionType } from "../shared/domain/orchestrationCriteria.entity";
import { ActionKey } from "../shared/domain/globalAction.types";

export const messages = defineMessages({
  title: {
    id: "orchestrator.scenario.title",
    defaultMessage: "Create Scenario",
  },
  active: {
    id: "orchestrator.scenario.active",
    defaultMessage: "Active",
  },
  ticker: {
    id: "orchestrator.scenario.ticker",
    defaultMessage: "ID",
  },
  name: {
    id: "orchestrator.scenario.name",
    defaultMessage: "Name",
  },
  drag: {
    id: "orchestrator.scenario.drag",
    defaultMessage: "Reorder",
  },
  engineConfig: {
    id: "orchestrator.scenario.engineConfig",
    defaultMessage: "Configuration to apply",
  },
  matchMode: {
    id: "orchestrator.scenario.matchMode",
    defaultMessage: "Match Mode",
  },
  conditions: {
    id: "orchestrator.scenario.conditions",
    defaultMessage: "Conditions",
  },
  conditionActions: {
    id: "orchestrator.scenario.conditionActions",
    defaultMessage: "Actions",
  },
  addCondition: {
    id: "orchestrator.scenario.addCondition",
    defaultMessage: "Add Condition",
  },
  segments: {
    id: "orchestrator.scenario.segments",
    defaultMessage: "Segments",
  },
  segmentActions: {
    id: "orchestrator.scenario.segmentActions",
    defaultMessage: "Actions",
  },
  addSegment: {
    id: "orchestrator.scenario.addSegment",
    defaultMessage: "Add Segment",
  },
  parameters: {
    id: "orchestrator.scenario.parameters",
    defaultMessage: "Parameters",
  },
  paramActions: {
    id: "orchestrator.scenario.paramActions",
    defaultMessage: "Actions",
  },
  addParam: {
    id: "orchestrator.scenario.addParam",
    defaultMessage: "Add Parameter",
  },
  save: {
    id: "orchestrator.scenario.save",
    defaultMessage: "Save",
  },
  saving: {
    id: "orchestrator.scenario.saving",
    defaultMessage: "Saving...",
  },
  back: {
    id: "orchestrator.scenario.back",
    defaultMessage: "Back",
  },
  loading: {
    id: "orchestrator.scenario.loading",
    defaultMessage: "Loading...",
  },
  defaultEngineConfig: {
    id: "orchestrator.scenario.defaultEngineConfig",
    defaultMessage: "Default",
  },
  [ConditionType.OCCUPANCY]: {
    id: "orchestrator.condition.occupancy",
    defaultMessage: "Occupancy",
  },
  [ConditionType.CHECK_IN_DAY]: {
    id: "orchestrator.condition.checkInDay",
    defaultMessage: "Check-in day",
  },
  [ConditionType.CHECK_OUT_DAY]: {
    id: "orchestrator.condition.checkOutDay",
    defaultMessage: "Check-out day",
  },
  [ConditionType.LENGTH_OF_STAY]: {
    id: "orchestrator.condition.lengthOfStay",
    defaultMessage: "Length of stay",
  },
  [ConditionType.BOOKING_WINDOW]: {
    id: "orchestrator.condition.bookingWindow",
    defaultMessage: "Booking window",
  },
  [ConditionType.TRAVEL_WINDOW]: {
    id: "orchestrator.condition.travelWindow",
    defaultMessage: "Travel window",
  },
  [ConditionType.NUMBER_OF_ROOMS]: {
    id: "orchestrator.condition.numberOfRooms",
    defaultMessage: "Number of rooms",
  },
  [ConditionType.DEVICE]: {
    id: "orchestrator.condition.device",
    defaultMessage: "Device",
  },
  [ConditionType.REFERRER]: {
    id: "orchestrator.condition.referrer",
    defaultMessage: "Referrer",
  },
  [ConditionType.UTM_SOURCE]: {
    id: "orchestrator.condition.utmSource",
    defaultMessage: "UTM Source",
  },
  [ConditionType.ORIGIN]: {
    id: "orchestrator.condition.origin",
    defaultMessage: "Origin",
  },
  [ActionKey.DISPLAY_MODE]: {
    id: "orchestrator.action.displayMode",
    defaultMessage: "Display mode",
  },
  [ActionKey.ACCOMMODATION_RESULTS_FORMAT]: {
    id: "orchestrator.action.accommodationResultsFormat",
    defaultMessage: "Accommodation results format",
  },
  [ActionKey.ACCOMMODATION_SORTING_CRITERIA]: {
    id: "orchestrator.action.accommodationSortingCriteria",
    defaultMessage: "Accommodation order",
  },
  [ActionKey.BOOKING_ADVANTAGES_POSITION]: {
    id: "orchestrator.action.bookingAdvantagesPosition",
    defaultMessage: "Booking advantages position",
  },
  [ActionKey.ENGINE_HIGHLIGHT_REEL_ORDER]: {
    id: "orchestrator.action.engineHighlightReelOrder",
    defaultMessage: "Highlights reel",
  },
  [ActionKey.SHOW_EXTRAS_CONFIGURATION]: {
    id: "orchestrator.action.showExtrasConfiguration",
    defaultMessage: "Show extras configuration",
  },
  [ActionKey.PRICE_CALENDAR]: {
    id: "orchestrator.action.priceCalendar",
    defaultMessage: "Price calendar",
  },
  [ActionKey.ENABLE_LOYALTY]: {
    id: "orchestrator.action.enableLoyalty",
    defaultMessage: "Enable loyalty",
  },
  [ActionKey.BOOK_AND_JOIN_TYPE]: {
    id: "orchestrator.action.bookAndJoinType",
    defaultMessage: "Book&Join type",
  },
  [ActionKey.ADD_MANDATORY_EXTRAS_TO_INVENTORY_RATE]: {
    id: "orchestrator.action.addMandatoryExtrasToInventoryRate",
    defaultMessage: "Add mandatory extras rate to room selection",
  },
  [ActionKey.SHOW_MANDATORY_EXTRAS]: {
    id: "orchestrator.action.showMandatoryExtras",
    defaultMessage: "Show mandatory extras",
  },
  [ActionKey.SHOW_ENGINE_DISCOUNT]: {
    id: "orchestrator.action.showEngineDiscount",
    defaultMessage: "Show engine discount",
  },
  [ActionKey.UNAVAILABLE_URL]: {
    id: "orchestrator.action.unavailableURL",
    defaultMessage: "Unavailable URL",
  },
  [ActionKey.BUTTON_ROUND_TYPE]: {
    id: "orchestrator.action.buttonRoundType",
    defaultMessage: "Button round type",
  },
  [ActionKey.TAG_ROUND_TYPE]: {
    id: "orchestrator.action.tagRoundType",
    defaultMessage: "Tag round type",
  },
  [ActionKey.BOOKING_FORM_ROUND_TYPE]: {
    id: "orchestrator.action.bookingFormRoundType",
    defaultMessage: "Booking form round type",
  },
  [ActionKey.CARD_ROUND_TYPE]: {
    id: "orchestrator.action.cardRoundType",
    defaultMessage: "Card round type",
  },
  [ActionKey.PAYMENT_TICKERS]: {
    id: "orchestrator.action.paymentTickers",
    defaultMessage: "Payment tickers",
  },
  [ActionKey.PROMOTIONALCODE]: {
    id: "orchestrator.action.promotionalcode",
    defaultMessage: "Promotional code",
  },
  [ActionKey.MESSAGE_CODE]: {
    id: "orchestrator.action.messageCode",
    defaultMessage: "Message code",
  },
  [ActionKey.TAB]: {
    id: "orchestrator.action.tab",
    defaultMessage: "Tab",
  },
  [ActionKey.SEGMENT]: {
    id: "orchestrator.action.segment",
    defaultMessage: "Segment",
  },
});
